<template>
  <div class="add-accommodation-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Add New Accommodation</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <form>
              <div class="form-group">
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Accommodation Name</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.name" placeholder="Accommodation Name" :class="hasError && !validateName ? 'is-invalid' : ''" />
                    <div v-if="hasError && !validateName" class="text-danger">Name is required.</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Address Line 1</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.address1" placeholder="Address Line 1" :class="hasError && !validateAddress1 ? 'is-invalid' : ''" />
                    <div v-if="hasError && !validateAddress1" class="text-danger">Address is required.</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Address Line 2</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.address2" placeholder="Address Line 2" />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">City</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.city" placeholder="City" :class="hasError && !validateCity ? 'is-invalid' : ''" />
                    <div v-if="hasError && !validateCity" class="text-danger">City is required.</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">State</div>
                  <div class="box-col box-col-right">
                    <select v-model="accommodation.state" :class="hasError && !validateState ? 'is-invalid' : ''">
                      <option value="" hidden>Select State</option>
                      <option v-for="state in states" :value="state.value">{{ state.text }}</option>
                    </select>
                    <div v-if="hasError && !validateState" class="text-danger">State is required.</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Postcode</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.postcode" placeholder="Accommodation Postcode" />
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left left-label">Phone Number</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="accommodation.phone" placeholder="Accommodation Number" :class="hasError && !validatePhone ? 'is-invalid' : ''" />
                    <div v-if="hasError && !validatePhone" class="text-danger">Phone is required.</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="callSave" dark>Save</v-btn>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'

  export default {
    name: 'AddAccommodationModal',
    data() {
      return {
        loadModal: false,
        hasError: false,
        accommodation: {
          name: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          postcode: '',
          phone: '',
        },
        index: -1,
        states: utilities.getStates(),
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      validateName() {
        if(this.accommodation.name == '') {
          return false
        }
        return true
      },
      validateAddress1() {
        if(this.accommodation.address1 == '') {
          return false
        }
        return true
      },
      validateCity() {
        if(this.accommodation.city == '') {
          return false
        }
        return true
      },
      validateState() {
        if(this.accommodation.state == '') {
          return false
        }
        return true
      },
      validatePhone() {
        if(this.accommodation.phone == '') {
          return false
        }
        return true
      },
    },
    methods: {
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },
      reset(index = -1) {
        this.accommodation = {
          name: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          postcode: '',
          phone: '',
        }
        this.hasError = false
        this.index = index
      },
      async callSave() {
        if (!this.validateName || !this.validateAddress1 || !this.validateCity || !this.validateState || !this.validatePhone) {
          this.hasError = true
          return
        }
        this.$store.dispatch('loading/setLoadComponent', true)
        var params = {
          AccommodationName:this.accommodation.name,
          AddressLine1:this.accommodation.address1,
          AddressLine2:this.accommodation.address2,
          City:this.accommodation.city,
          State:this.accommodation.state,
          Postcode:this.accommodation.postcode,
          Country:'AU',
          PhoneNumber:this.accommodation.phone,
          UserID: this.user.id,
          Username: this.user.name
        }
        var accommodationId = await utilities.postNewAccommodation(params)
        if(accommodationId > 0) {
          var accommodations = await utilities.getAccommodations()
          this.$parent.accommodations = _.cloneDeep(accommodations)
          this.$parent.originalListAccommodations =  _.cloneDeep(utilities.getDropdownAccommodation(accommodations))
          this.$parent.listAccommodations = _.cloneDeep(this.$parent.originalListAccommodations)
          this.$parent.updateListAccommodationsArray()
          this.$parent.accommodationKey += 1
          if(this.index > -1) {
            this.$parent.travelAccommodations[this.index].accommodationId = accommodationId
            this.$parent.updateAccommodation(accommodationId, this.index)
            setTimeout(() => {
              this.$parent.setNewAccommodation(accommodationId, this.index)
            }, 500)
          }
          this.handleModal()
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },
    },
    mounted() {},
  }
</script>
